export const version = '1.3.0-beta.5'
